export default "__VITE_ASSET__BNNQllXl__"